import React, { useEffect } from 'react'

import styles from './MasternodeNew.module.scss'
import images from 'assets/images'
import Button from 'components/Button'
import useResizeWidth from 'controller/useResizeWidth'
import axios from 'axios'
import { toFormatted } from 'commons/function'

function MasternodeNew() {
  const { positionY } = useResizeWidth()
  const hearthRef = React.useRef(null)
  const hearthRefHeight = hearthRef.current ? hearthRef.current.offsetTop : 0
  const hearthChange = positionY > hearthRefHeight + 76

  const [dataCurrent, setDataCurrent] = React.useState(0)

  const onGetData = async () => {
    try {
      const res = await axios.get('https://www.zencard.io/api/masternode/stats')
      // const data = await res.json()
      console.log({ res })
      // setTicketNumber(get(data, 'totalSupplyNumber', 0))
      setDataCurrent(res.data.averageOwnerROI)
    } catch (error) {
      console.log({ error })
    }
  }

  useEffect(() => {
    onGetData()
  }, [])

  return (
    <div className={styles.masternodeNew}>
      <div className='masternode-new'>
        <div className='masternode-banner'>
          <div className='masternode-banner-wrapper'>
            <div className='masternode-banner-container'>
              <div className='banner-content'>
                <div
                  className={`banner-top ${
                    positionY > 0 && 'banner-top--move-up'
                  }`}>
                  <div className='banner-top__title'>
                    <h1>Empowering Decentralization</h1>
                    <div className='title-sub'>Owned By Everyone</div>

                    <div className='title-description'>
                      With every <span>$VIC</span> staked, you're building a
                      faster, more secure Viction
                    </div>

                    <div className='btn-banner'>
                      <a
                        href='https://docs.viction.xyz/masternode/run-a-full-node'
                        target='_blank'
                        rel='noreferrer'>
                        <Button>
                          Run a masternode{' '}
                          <span className='icon-web_arrow_up_right arrow-icon'></span>
                        </Button>
                      </a>

                      <div className='text-hover-underline-white text-action'>
                        <a href='https://www.vicmaster.xyz/'>
                          Delegate $VIC and Earn Rewards
                        </a>
                      </div>
                    </div>
                  </div>

                  <div className='line-curve'>
                    <img
                      src={images.lineCurve}
                      alt='Line curve'
                      className='img-line'
                    />
                  </div>

                  <img
                    src={images.masternodeBanner}
                    alt='masternode-banner'
                    className='img-banner'
                  />
                </div>

                <div
                  className={`banner-masternode-bottom ${
                    positionY > 0 && 'banner-masternode-bottom--move-up'
                  }`}>
                  <div className='banner-bottom-container'>
                    <div className='banner-bottom-content'>
                      <div
                        className={`content-bottom content-bottom--left ${
                          positionY > 0 && 'content-bottom--left--move-up'
                        }`}>
                        <div className='content-left-img'>
                          <img
                            src={images.bannerBottom}
                            alt=''
                            className={`img-item img-item--center ${
                              positionY > 0 && 'img-item--center--rotate'
                            }`}
                          />

                          {/* <img
                            src={images.coinBannerBottom}
                            alt=''
                            className='img-item-sub img-item-sub--coin img-item-sub--coin--coin-1'
                          />
                          <img
                            src={images.coinBannerBottom}
                            alt=''
                            className='img-item-sub img-item-sub--coin img-item-sub--coin--coin-2'
                          />

                          <img
                            src={images.starBannerBottom}
                            alt=''
                            className='img-item-sub img-item-sub--star img-item-sub--star--star-1'
                          />
                          <img
                            src={images.starBannerBottom}
                            alt=''
                            className='img-item-sub img-item-sub--star img-item-sub--star--star-2'
                          /> */}
                        </div>
                      </div>
                      <div className='content-bottom content-bottom--right'>
                        <div className='content-bottom-item'>
                          <div className='item-number'>
                            {toFormatted(dataCurrent, false, 1)}%
                          </div>

                          <div className='item-text'>
                            Current Masternode APR
                          </div>
                        </div>

                        <div className='content-bottom-item'>
                          <div className='item-number'>150</div>

                          <div className='item-text'>
                            Current number of Masternode
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className='curve-up-wrapper'>
            <img src={images.curveBlackUp} alt='' className='curve-up' />
          </div>
        </div>

        <div className='masternode-hearth' ref={hearthRef}>
          <div className='masternode-hearth-container'>
            <div className='hearth-content'>
              <div
                className={`hearth-top ${
                  hearthChange && 'hearth-top--change'
                }`}>
                <div className='hearth-top-heading'>
                  <div className='top-heading-title'>
                    Masternodes At <br /> The Heart Of Viction
                  </div>

                  <div className='top-heading-description'>
                    Masternodes are the network and ensuring transaction
                    accuracy, while driving consensus for a resilient blockchain
                    platform.
                  </div>
                </div>
              </div>

              <div
                className={`hearth-bottom ${
                  hearthChange && 'hearth-bottom--change'
                }`}>
                <div className='hearth-bottom-title'>Masternode ROI</div>

                <div className='hearth-bottom-content'>
                  <div className='content-detail'>
                    <div className='content-item content-item--item-1'>
                      <div className='item-content-img'>
                        <img
                          src={images.rewardShare}
                          alt=''
                          className='content-img'
                        />
                      </div>

                      <div className='item-content-detail'>
                        <div className='detail-title'>
                          How Rewards Are Shared
                        </div>

                        <div className='detail-info'>
                          Learn when and how VIC is distributed every epoch
                          between Masternodes and Stakers.
                        </div>

                        <div className='detail-more'>
                          <div className='text-hover-underline text-more'>
                            <a
                              href='https://docs.viction.xyz/general/staking/staking-rewards'
                              target='_blank'
                              rel='noopener noreferrer'>
                              Learn More
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className='content-item content-item--item-2'>
                      <div className='item-content-img'>
                        <img
                          src={images.setupGuide}
                          alt=''
                          className='content-img'
                        />
                      </div>

                      <div className='item-content-detail'>
                        <div className='detail-title'>
                          Masternode Setup Guide
                        </div>

                        <div className='detail-info'>
                          Full guide to start and operate a Masternode.
                        </div>

                        <div className='detail-more'>
                          <div className='text-hover-underline text-more'>
                            <a
                              href='https://docs.viction.xyz/faq/masternode-and-voting/masternode#what-rewards-do-masternodes-receive'
                              target='_blank'
                              rel='noopener noreferrer'>
                              Learn More
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div
              className={`img-banner-wrapper ${
                hearthChange && 'img-banner-wrapper--change'
              }`}>
              <img
                src={images.masternodeHearthBanner}
                alt=''
                className='img-banner'
              />
            </div>
          </div>
        </div>

        <div className='masternode-validating'>
          <div className='masternode-validating-container'>
            <div className='validating-content'>
              <div className='validating-content-title'>
                <div className='content-title-text'>Validating On Viction</div>
              </div>

              <div className='validating-content-detail'>
                <div className='detail-item'>
                  <div className='detail-item__icon'>
                    <span className='icon-ic-move item-icon'></span>
                  </div>

                  <div className='detail-item__info'>
                    <div className='info-name'>Run a Masternode</div>

                    <div className='info-content'>
                      Explore our documentation related to information on how to
                      setup and run a Masternode on Viction.
                    </div>
                  </div>
                </div>
                <div className='detail-item'>
                  <div className='detail-item__icon'>
                    <span className='icon-ic-staking item-icon'></span>
                  </div>

                  <div className='detail-item__info'>
                    <div className='info-name'>Start Staking</div>
                    <div className='info-content'>
                      Find everything you need to start staking in our detailed
                      guide.
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default MasternodeNew
